<template>
  <div class="template">
        <p class="add-btn" @click="addIndustrial">增加新行业</p>
        <div class="industrial-manage-center" v-for="(item,index) in apiData.industryList" :key="index">
            <div class="industrial-manage-center-header">
              <div class="industrial-manage-center-header-left">
                <div class="industrial-manage-center-header-tit">行业名：</div>
                <div class="industrial-manage-center-header-select">
                    <Input v-model="item.name" placeholder="请输入" style="width: 160px" />
                </div>
                <div class="home-display-item-select">
                    <div class="upload-Img">
                      <div v-if="item.img" class="look-img">
                        <img :src="item.img" style="width:40px;height:40px" />
                        <div class="demo-upload-list-cover">
                          <Icon
                            type="ios-trash-outline"
                            @click.native="deleteFile(index)"
                          ></Icon>
                        </div>
                      </div>
                        <template v-else>
                            <Upload
                                :action="uploadUrl"
                                :headers="headers"
                                :on-error="uploadErr"
                                :on-success="(value) => uploadSuccess('index', value,index)"
                                name="file"
                                :show-upload-list="false"
                            >
                                <div class="upload-btn">
                                    <Icon
                                        type="ios-cloud-upload"
                                        size="20"
                                        style="color: #3399ff"
                                    ></Icon>
                                </div>
                            </Upload>
                        </template>
                    </div>
                </div>
               <div class="industrial-manage-item-right">
                    <img @click="getSort(index,'up')" src="@/assets/images/arrow_up.png">
                    <img @click="getSort(index,'down')" src="@/assets/images/arrow_down.png">
                    <!-- <img @click="editClassification(index,idx)" src="@/assets/images/edit.png"> -->
                    <img @click="saveClassification(item)" src="@/assets/images/save.png">
                    <!-- <img @click="deleteClassification(items,index,idx)" src="@/assets/images/delete.png"> -->
                </div>
              </div>
              <p @click="deleteClassification(item,index)" class="detele-btn">删除属性</p>
            </div>
            <div class="industrial-manage-item" v-for="(items,idx) in item.children" :key="idx">
                <div class="industrial-manage-item-left">                 
                    <div class="industrial-manage-item-tit"></div>
                    <div class="industrial-manage-item-select">
                        <Input v-model="items.name" placeholder="请输入" style="width: 160px" />
                    </div>
                </div>
                <div class="industrial-manage-item-right">
                    <img @click="getSonSort(index,idx,'up')" src="@/assets/images/arrow_up.png">
                    <img @click="getSonSort(index,idx,'down')" src="@/assets/images/arrow_down.png">
                    <!-- <img @click="editClassification(index,idx)" src="@/assets/images/edit.png"> -->
                    <img @click="saveClassificationSon(item,items)" src="@/assets/images/save.png">
                    <img @click="deleteClassification(items,index,idx)" src="@/assets/images/delete.png">
                </div>
            </div>
             <div class="industrial-manage-center-header">
              <div class="industrial-manage-center-header-left">
                <div class="industrial-manage-center-header-tit"></div>
                <div class="industrial-manage-center-header-select">
                   <p class="detele-btn" @click="addChild(item,index)">添加子属性</p>
                </div>
              </div>
              
            </div>
            
        </div>
  </div>
</template>

<script>
import {apiIndustryList,apiIndustryDelete,apiIndustryProductMove,apiIndustrySave,apiIndustryUpdate} from '@/api/industrial-manage.js'
export default {
  name: "industrial-manage",
  data() {
    return {
         headers: {
        token: localStorage.getItem("token"),
      },
      uploadUrl: process.env.VUE_APP_API_URL + "/upload-file",
      // query参数
      query: {},
      // 搜索参数
      search: {},
      diyDom: {},
      diyData: {
      },
      apiData:{
        industryList:[],
      }
    };
  },
  methods: {
    getInfro(){
      apiIndustryList().then(res=>{
         var obj=[]
            for(var i=0;i<res.data.length;i++){
                if(res.data[i].level==1){
                    var data=res.data[i]
                    data.children=[]
                    data.isEdit=false
                    obj.push(data)
                }else{
                    obj=obj.map(item=>{
                        if(item.id==res.data[i].parentId){
                            var children=res.data[i]
                            children.isEdit=false
                            item.children.push(children)
                        }
                        return item
                    })
                }
               
            }
        this.apiData.industryList=obj
        console.log(obj)
      })
    },
    addIndustrial(){
      var obj={
        children:[],
        img:'',
        name:'',
        level:1,
        parentId:0
      }
      this.apiData.industryList.push(obj)
    },
    //添加子属性
    addChild(item,index){
      var obj={
        img:'',
        name:'',
        level:2,
        parentId:item.parentId
      }
      this.apiData.industryList[index].children.push(obj)
    },
    //保存
    getConfirm(){
        
    },

     //保存
    saveClassification(item){
      if(item.id){
        var opt={
          id:item.id,
          level:item.level,
          name:item.name,
          parentId:item.parentId,
          img:item.img,
        }
        apiIndustryUpdate(opt).then(res => {
          this.$Message.success('操作成功');
          // this.getInfro()
        });
      }else{
       var opt={
         level:item.level,
          name:item.name,
          parentId:item.parentId,
          img:item.img,
        }
        apiIndustrySave(opt).then(res => {
          this.$Message.success('操作成功');
          // this.getInfro()
        });
      }
    },
    //子组件
    saveClassificationSon(item,items){
      if(items.id){
        var opt={
          id:items.id,
          level:items.level,
          name:items.name,
          parentId:items.parentId,
          img:items.img,
        }
        apiIndustryUpdate(opt).then(res => {
          this.$Message.success('操作成功');
          // this.getInfro()
        });
      }else{
       var opt={
         level:items.level,
          name:items.name,
          parentId:item.id,
          img:items.img,
        }
        apiIndustrySave(opt).then(res => {
          this.$Message.success('操作成功');
          // this.getInfro()
        });
      }
    },

      getSort(index,type){
      
      if(type=='up'){
        var opt={
          id1:this.apiData.industryList[index-1>0?index-1:0].id,
          id2:this.apiData.industryList[index].id,
         }
         console.log(opt,'up')
      }else if(type=='down'){
         var opt={
          id1:this.apiData.industryList[index].id,
          id2:this.apiData.industryList[index+1>=this.apiData.industryList.length?index:index+1].id,
         }
          console.log(opt,'down')
      }
      apiIndustryProductMove(opt).then(res => {
        this.getInfro()
      });
    },
    getSonSort(index,idx,type){
      if(type=='up'){
         var opt={
          id1:this.apiData.industryList[index].children[idx-1>0?idx-1:0].id,
          id2:this.apiData.industryList[index].children[idx].id,
         }
      }else{
          var opt={
          id1:this.apiData.industryList[index].children[idx].id,
          id2:this.apiData.industryList[index].children[idx+1>=this.apiData.producttypeList[index].children.length?idx:idx+1].id,
         }
      }
      apiIndustryProductMove(opt).then(res => {
        this.getInfro()
      });
    },
     //删除
    deleteClassification(item,index,idx){
      if(item.id){
        this.$Modal.confirm({
            title: '提示',
            content: '确认删除当前分类？',
            onOk: () => {
                apiIndustryDelete({
                    ids: item.id
                }).then(res => {
                    this.$Message.success('操作成功');
                    this.getInfro();
                });
            }
        });
      }else{
        if(item.level==1){
          this.apiData.industryList.splice(index,1)
        }else if(item.level==2){
          this.apiData.industryList[index].children.splice(idx,1)
        }
      }
      
    },
     uploadSuccess(type, res, index = 0) {
      if (res.code != 200) {
        return this.$Modal.error({ title: "提示", content: res.msg });
      }
      this.$Message.success("文件上传成功");
      // if(type=='img'){
        this.apiData.industryList[index].img=res.data.fileUrl
        console.log(this.apiData.industryList[index].img)
      // }
      
    },
    // 文件上传失败
    uploadErr() {
      this.$Spin.hide();
      this.$Modal.error({
        title: "提示",
        content: "文件上传失败，请重试",
      });
    },
    // 查看文件
    lookFile(url) {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.target = "_blank";
      a.href = url;
      a.click();
      document.body.removeChild(a);
    },
    // 删除文件
    deleteFile(index) {
      this.$Modal.confirm({
        title: "提示",
        content: "确认删除文件？",
        onOk: () => {
          this.apiData.industryList[index].img=''
          
        },
      });
    },
   
  },
  mounted() {
    this.getInfro()
  },
};
</script>

<style scoped lang="less">
.template{
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
    .title{
        font-size: 18px;
        font-weight: 400;
        margin-bottom: 20px;
    }
    .industrial-manage-center{
        background: rgba(229, 229, 229, 0.5);
        width: 100%;
        max-width: 700px;
        padding: 20px;
        margin-bottom: 10px;
        .industrial-manage-center-header{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .industrial-manage-center-header-left{
              display: flex;
            align-items: center;
            }
            .industrial-manage-center-header-select{
                margin-right: 10px;
            }
            .industrial-manage-item-right{
                  display: flex;
                align-items: center;
                img{
                width: 16px;
                height: 16px;
                margin-left: 20px;
                display: block;
                cursor: pointer;
            }
            }
        }
        .industrial-manage-item{
            width: 100%;
            margin-top: 10px;
            display: flex;
            align-items: center;
            // justify-content: space-between;
             margin-bottom: 10px;
            .industrial-manage-item-left{
                    display: flex;
                align-items: center;
                .industrial-manage-item-select{
                    margin-right: 10px;
                }
            }
            .industrial-manage-item-right{
                  display: flex;
                align-items: center;
                img{
                width: 16px;
                height: 16px;
                margin-left: 20px;
                display: block;
                cursor: pointer;
            }
            }
            
        }
    }
    .add-btn{
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        color: rgba(42, 130, 228, 1);
        text-align: left;
        line-height: 36px;
        margin-top: 20px;
        cursor: pointer;
  }
}
.detele-btn{
  font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        color: rgba(42, 130, 228, 1);
        text-align: left;
        line-height: 36px;
        cursor: pointer;
}
.upload-btn{
    background: #F7F8FA;
    width: 40px;
    height: 40px;
}
.industrial-manage-center-header-tit,.industrial-manage-item-tit{
width: 80px;
}
.look-img{
  margin-left: 0px;
  width: 40px;
  height: 40px;
  img{
    margin-left: 0px;
  }
 
}
 .upload-Img .demo-upload-list-cover i{
    line-height: 40px !important;
  }
</style>
